import {
  GetConfigCompareRequestQueryParamType,
  GetConfigCompareResponseBodyType,
} from "@intelligems/ig-types";
import { useQueries, useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { historyKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const getConfigCompare = async (
  payload: ApiRequest<any, any, GetConfigCompareRequestQueryParamType>
) => {
  const resp = await api.get<GetConfigCompareResponseBodyType>(
    `/v2/configs/compare`,
    {
      params: { ...payload.queryParams },
    }
  );
  return resp.data;
};

export const useConfigCompare = (
  params: { from: string; to: string },
  options?: QueryOptions<GetConfigCompareResponseBodyType, Error>
) => {
  return useQuery<GetConfigCompareResponseBodyType, Error>({
    ...options,
    queryKey: historyKeys.getConfigCompare(params.from, params.to),
    queryFn: async () =>
      getConfigCompare({
        body: undefined,
        queryParams: {
          from: params.from,
          to: params.to,
        },
        pathParams: undefined,
      }),
  });
};

export const useConfigCompareQueries = (
  params: { from: string; to: string }[]
) => {
  return useQueries<GetConfigCompareResponseBodyType[]>({
    queries: params.map((param) => ({
      queryKey: historyKeys.getConfigCompare(param.from, param.to),
      queryFn: async () =>
        getConfigCompare({
          body: undefined,
          queryParams: {
            from: param.from,
            to: param.to,
          },
          pathParams: undefined,
        }),
    })),
  });
};
